import React from "react";
import "./Hero.css"
import Herobg from "../../herobg.avif";

const Hero = () => {
  return (
    <section className="hero fade-up" id="about" style={{backgroundImage:`url(${Herobg})`}}>
      <div className="hero-content">
        <h1 className="hero-title">
          Discover Rhymes <br />
         From Every Artist
        </h1>

        <p className="hero-description">
          NourTune is a digital rhyme library powered by Telelumiere Channel.
          Explore rhymes from singers and artists across all occasions and
          categories. Save, download, and organize your favorites through your
          personal profile.
        </p>

        {/* <div className="hero-cta">
            <button className="btn btn-primary">Get Started</button>
            <button className="btn btn-secondary">Learn More</button>
          </div> */}

        <div className="hero-stats mb-3">
          <div className="stat-item">
            <span className="stat-number">10K+</span>
            <span className="stat-label">Rhymes</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">5K+</span>
            <span className="stat-label">Artists</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">1M+</span>
            <span className="stat-label">Lines</span>
          </div>
        </div>
          <button className="get-notified">
            Get Notified
          </button>
      </div>

      {/* <div className="hero-visual">
          <div className="rhyme-cards">
            {[1, 2, 3].map((item) => (
              <div key={item} className="rhyme-card">
                <div className="card-wave"></div>
                <p className="card-rhyme">
                  "Flow like a river, deliver the shiver..."
                </p>
              </div>
            ))}
          </div>
        </div> */}
    </section>
  );
};

export default Hero;
